/* @jsxImportSource @emotion/react */

import React from 'react'
import { css } from '@emotion/react'
import { FormattedMessage } from 'react-intl'

import { sliteWebsiteCustomerList } from '@slite/components'

import { MEDIUM_BREAKPOINT, SMALL_BREAKPOINT } from '../utils/breakpoints'

export function CustomerLogosWall({
  heading,
  customers = sliteWebsiteCustomerList,
}: {
  heading?: React.ReactNode
  customers?: typeof sliteWebsiteCustomerList
}) {
  return (
    <div
      className="text-align-center"
      css={css`
        font-size: 16px;
      `}
    >
      {heading ?? (
        <span className="font-weight-semibold shade-10">
          <FormattedMessage
            id="new.hero.customerwall"
            defaultMessage="Trusted by 1,700+ companies as their single source of truth."
          />
        </span>
      )}
      <div
        css={css`
          display: grid;
          width: 100%;
          margin-left: auto;
          margin-right: auto;
          grid-template-columns: repeat(6, 1fr);
          grid-template-rows: 1fr;
          @media (max-width: ${MEDIUM_BREAKPOINT - 1}px) {
            grid-template-columns: repeat(3, 1fr);
            grid-template-rows: repeat(2, 1fr);
            height: auto;
          }
          @media (max-width: ${SMALL_BREAKPOINT - 1}px) {
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: repeat(3, 1fr);
            height: auto;
          }
        `}
      >
        {customers.map(({ logo: Logo, name }) => (
          <div
            key={name}
            className="flexbox flexbox-column flexbox-align-center flexbox-justify-end min-width-zero"
            css={css`
              height: 100px;
            `}
          >
            <Logo
              css={css`
                height: 28px;
                width: auto;
                max-width: 100%;
                object-fit: contain;
                display: block;
                @media (max-width: ${SMALL_BREAKPOINT - 1}px) {
                  height: 20px;
                }
              `}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
